import React from 'react';
import { DataValue, Poppins } from './Poppins';
import { NoData } from './NoData';
import { Tooltip } from './Tooltip';
import { numeralFormat } from 'src/utils/misc';
import * as S from './VariantValues.styles';

interface VariantValuesProps {
  value?:
    | number
    | null
    | {
        base?: number | null;
        live?: number | null;
        cpmplete?: number | null;
      };
  flat?: boolean;
  /** Lay the three values out horizontally with no separators (matches the scenario-detail cards). */
  inline?: boolean;
  tooltipText?: {
    base?: string;
    live?: string;
    cpmplete?: string;
  };
}

export const VariantValues: React.FC<VariantValuesProps> = ({ value, flat, inline, tooltipText = {} }) => {
  if (!value) return <NoData techIncomplete />;
  if (typeof value === 'number') return <DataValue>{numeralFormat(value)}</DataValue>;

  return (
    <S.Dots $flat={flat} $inline={inline}>
      <Tooltip dataHtml={tooltipText.base || 'Unmodified value'} dataId="base" place="top">
        <div className="item">
          <div className="item__dot item__dot--base" />
          <Poppins px={14} weight={500} className="item__label">
            {numeralFormat(value.base)}
          </Poppins>
        </div>
      </Tooltip>
      {flat && <div className="separator"></div>}
      <Tooltip dataHtml={tooltipText.live || 'Live value'} dataId="live" place="top">
        <div className="item">
          <div className="item__dot item__dot--live" />
          <Poppins px={14} weight={500} className="item__label">
            {numeralFormat(value.live)}
          </Poppins>
        </div>
      </Tooltip>
      {flat && <div className="separator"></div>}
      <Tooltip dataHtml={tooltipText.cpmplete || 'Projected value'} dataId="complete" place="top">
        <div className="item">
          <div className="item__dot item__dot--complete" />
          <Poppins px={14} weight={500} className="item__label">
            {numeralFormat(value.cpmplete)}
          </Poppins>
        </div>
      </Tooltip>
    </S.Dots>
  );
};
